"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stringUtils = require("../../utils/stringUtils");
var Icons = _interopRequireWildcard(require("../../icons-react/facilities"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getIconName = function getIconName(type) {
  return "".concat(/^\d/.test(type) ? '_' : '').concat((0, _stringUtils.pascalCase)(type));
};
var FacilityIcon = function FacilityIcon(_ref) {
  var type = _ref.type,
    className = _ref.className,
    name = _ref.name;
  var compName = type ? getIconName(type) : 'Included';
  // eslint-disable-next-line import/namespace
  var Icon = Icons["".concat(compName)] || Icons.Included;
  return /*#__PURE__*/_react["default"].createElement(Icon, {
    "data-text-hint": name,
    className: className
  });
};
var StyledFacilityIcon = (0, _styledComponents["default"])(FacilityIcon).withConfig({
  displayName: "FacilityIcon__StyledFacilityIcon",
  componentId: "sc-1x1a4ay-0"
})(["width:24px;height:24px;stroke-width:1;"]);
var _default = exports["default"] = StyledFacilityIcon;